// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__7lFJw","large":"styles_large__25m-5"};